<template>
  <div class="dataForm" style="min-width:1000px;" v-if="detail">
    <div class="form-title mb-10">
      <span class="label blue" >业</span>
      <span class="left">业务信息</span>
    </div>
    <el-descriptions >
      <el-descriptions-item label="编号：">{{detail.business.no}}</el-descriptions-item>
      <el-descriptions-item label="名称：">{{detail.business.name}}</el-descriptions-item>
      <el-descriptions-item label="品牌：">{{detail.business.brand}}</el-descriptions-item>
      <el-descriptions-item label="数量：">{{detail.business.amount}}</el-descriptions-item>
      <el-descriptions-item label="税率：">{{detail.business.orderTaxRate ? `${detail.business.orderTaxRate}%` : '未订单' }}</el-descriptions-item>
      <el-descriptions-item label="含税单价：">{{
          detail.business.orderFee ? $currency(detail.business.orderFee) : '未订单'
        }}</el-descriptions-item>
      <el-descriptions-item label="未税单价：">{{detail.business.orderFee ? $currency(detail.business.orderFee / (1 + detail.business.orderTaxRate / 100)) : '未订单'}}</el-descriptions-item>
      <el-descriptions-item label="含税总价：">{{ detail.business.orderFee ? $currency((detail.business.amount ?? 0) * (detail.business.orderFee ?? 0)) : '未订单'}}</el-descriptions-item>
      <el-descriptions-item label="未税总价：">{{
          detail.business.orderFee ? $currency(detail.business.orderFee / (1 + detail.business.orderTaxRate / 100) * (detail.business.amount ?? 0)) : '未订单'
        }}</el-descriptions-item>
      <el-descriptions-item label="单位：">{{detail.business.unit}}</el-descriptions-item>
      <el-descriptions-item label="型号：">{{detail.business.model}}</el-descriptions-item>
      <el-descriptions-item label="序列号：">{{detail.business.serial}}</el-descriptions-item>
      <el-descriptions-item label="客户公司名称：">{{detail.customerCompany}}</el-descriptions-item>
      <el-descriptions-item label="外包公司：">{{detail.outsourceCompany}}</el-descriptions-item>
    </el-descriptions>

    <div class="form-title mb-10 mt-30">
      <span class="label yellow" >审</span>
      <span class="left">审批信息</span>
    </div>
    <AccountPreview :account="detail.fee.account">
      <template v-slot:content>
        <el-descriptions-item label="总费用：">{{$currency(detail.fee.fee)}}</el-descriptions-item>
        <el-descriptions-item label="是否含税 ：">{{detail.fee.containsRate}}</el-descriptions-item>
        <el-descriptions-item label="税率：" v-if="detail.fee.containsRate === '是'">{{detail.fee.rate}}%</el-descriptions-item>
        <el-descriptions-item label="申请时间：">{{detail.fee.createTime}}</el-descriptions-item>
        <el-descriptions-item label="申请次数：">{{detail.times}}</el-descriptions-item>
        <el-descriptions-item label="发票类型：">{{detail.fee.invoiceType}}</el-descriptions-item>

      </template>
    </AccountPreview>
    <div class="form-title mb-10 mt-30">
      <span class="label green" >历</span>
      <span class="left">历史申请费用</span>
    </div>
    <el-table
      :data="detail.history || []"
      border
      fit
      row-key="id"
      class="fullWidth"
      :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
    >
      <el-table-column prop="fee" label="总费用" align="right">
        <template #default="{ row }">
          {{$currency(row.fee)}}
        </template>
      </el-table-column>
      <el-table-column prop="containsRate" label="是否含税" />
      <el-table-column prop="rate" label="税率">
        <template #default="{ row }">
          {{row.rate}}%
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="申请时间" min-width="130"/>
      <el-table-column prop="invoiceType" label="发票类型" />
      <el-table-column prop="times" label="申请次数" />
      <el-table-column prop="account.alias" label="账号信息" min-width="150"/>

    </el-table>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, onMounted, nextTick, unref } from 'vue'
import { ArrayRowsItem } from '@/model/Index'

import { ElMessage, ElForm } from 'element-plus'
import { createOutsourceFee, updateOutsourceFee } from '@/apis/OutsourceFee'
import AccountPreview from '@/views/business/outsourceCompany/AccountPreview/Index.vue'
import { useI18n } from 'vue-i18n'
import $currency from 'currency.js'

export default defineComponent({
  methods: { $currency },
  components: {
    AccountPreview
  },
  props: {
    id: { type: Number, required: false, default: 0 },
    api: { type: String, required: true },
    detail: { type: Object, required: true, default: () => null }

  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()

    const dataForm = ref(ElForm)
    const BusinessList = ref({})

    const dataMap = reactive({
      detail: props.detail,
      submitLoading: false,
      ruleForm: {
        fee: '',
        taxRate: '',
        customerCompanyId: '',
        customerNo: '',
        mark: '',
        details: []
      },
      rules: {
        titleId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        taxRate: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        customerCompanyId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        details: []
      },
      titleOption: [],
      companyOption: [],
      dialogVisible: false,
      selectBusinessList: [],
      taxRateList: [],
      excludeIds: [],

      handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const tempData = dataMap.ruleForm
              const formSate = !props.id ? 'add' : 'edit'
              if (formSate === 'add') {
                await createOutsourceFee(tempData)
              } else {
                await updateOutsourceFee(props.id, tempData)
              }
              dataMap.submitLoading = false
              context.emit('update:visibel')
              context.emit('submit')
              ElMessage({
                message: !props.id ? '创建成功' : '编辑成功',
                type: 'success',
                duration: 2000
              })
            } catch (err:any) {
              console.log(err, 'err')
              dataMap.submitLoading = false
              if (err && err.errors) {
                err.errors.forEach((item: any) => {
                  const field = dataMap.rules[item.field][0]
                  if (field) {
                    field.message = null
                    nextTick(() => {
                      field.message = item.defaultMessage
                    })
                  }
                })
              }
            }
          }
        })
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      }
    })
    onMounted(() => {
      console.log(props.detail, 2222)
      // dataMap.clearValidate()
    })
    return { t, ...toRefs(dataMap), dataForm, BusinessList }
  }
})
</script>
